<h2 mat-dialog-title>Your Patreon Account</h2>
<mat-dialog-content>
    @if (data.user.connections.patreon) {
        <p>
            You currently have the following Patreon account linked to your account:<br>
            <b>{{data.user.connections.patreon.username}}</b><br>
            @if (data.user.connections.patreon.subscriptionTier) {
                <span [style.color]="data.user.connections.patreon.subscriptionTier.color">({{data.user.connections.patreon.subscriptionTier.name}})</span>
            }
        </p>
    } @else {
        <p>
            You do not have a Patreon account linked to your account.<br>
            Click on the button below to link your Patreon account.<br>
            <a routerLink="/patreon" mat-dialog-close>Learn more about Patreon Perks</a>
        </p>
    }
</mat-dialog-content>
<mat-dialog-actions>
    @if (!data.user.connections.patreon) {
        <div style="display: inline-flex; flex-direction: column; gap: 4px;">
            <button style="width: fit-content;" mat-button [disabled]="!pow && !powError" (click)="connectPatreon()">{{ pow ? 'Connect' : (powError ? 'Retry' : 'Preparing...') }}</button>
            @if (!pow && !powError) {
                <app-pow-progress />
            }
        </div>
    } @else {
        <button style="width: fit-content;" mat-button (click)="disconnectPatreon()">Disconnect</button>
    }
    <button style="width: fit-content;" mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>